<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
<!--    <feather-icon-->
<!--      icon="Trash2Icon"-->
<!--      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"-->
<!--      @click="confirmDeleteRecord"-->
<!--    />-->
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";
export default {
  name: "CellRendererActions",
  methods: {
    editRecord () {
      // this.$router.push(`/admin/user/user-edit/${ 268}`).catch(() => {})

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose*/
      console.log("inside edit record")

      this.$router
        .push(`/user/trainee-list/user-edit/${this.params.data.id}`)
        .then(res => {
          console.log(this.params.data.id, res);
        })
        .catch(err => {
          console.log("update err", err);
        });
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: i18n.t('notification.user.profile.confirm.c1'),
        text:  i18n.t('notification.user.profile.confirm.c2',{ username: this.params.data.firstName}),
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      const uuid4 = require('uuid4');

      const dataObj = {
        id: this.params.data.id,
        status: 'deleted',
        email: `${this.params.data.email  }.deleted.${  uuid4()}`
      }
      this.$store
        .dispatch("userManagement/removeRecord", dataObj)
        .then((res) => {
          console.log('going to remove user', res)
          this.$vs.notify({
            color: "primary",
            title: i18n.t('notification.user.traineeList.removeRecord.success.r1'),
            text:  i18n.t('notification.user.traineeList.removeRecord.success.r2')
          });
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: i18n.t('notification.user.traineeList.removeRecord.failed.r1'),
            text:  i18n.t('notification.user.traineeList.removeRecord.failed.r2')
          });
        });
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: "primary",
        title: i18n.t('notification.user.traineeList.removeRecord.success.r1'),
        text:  i18n.t('notification.user.traineeList.removeRecord.success.r2')
      });
    }
  }
};
</script>
